<template>
  <tk-btn
    outline
    dark
    color="white"
    class="base-btn"
    large
    :type="type"
    :loading="loading"
  >
    <span class="caption font-weight-medium">
      <slot/>
    </span>
  </tk-btn>
</template>

<script>
export default {
  name: 'Btn',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style lang="scss">
.base-btn{
}

</style>
